import { Drive } from "../../../common/types/drive";
import { convertToGB } from "../../../common/util/convertToGb";
import { PieChart } from "../../atoms/Charts/PieChart";
import { DriveStatusItem } from "../../atoms/DriveStatusItem";
import * as S from "./DBDriveStatus.style";

interface DBDriveStatusProps {
  type?: "ssd" | "hdd";
  drive: Drive;
  isLoading: boolean;
}

export const DBDriveStatus = ({
  type,
  drive,
  isLoading,
}: DBDriveStatusProps) => {
  const { ssd, hdd } = drive;

  const total = type === "ssd" ? ssd?.total : hdd?.total;
  const system = type === "ssd" ? ssd?.system : hdd?.system;
  const used = type === "ssd" ? ssd?.used : hdd.used ?? 0;
  /** 잔여공간 */
  const avail = type === "ssd" ? ssd?.avail : hdd.avail ?? 0;

  const getChartData = () => {
    if (isLoading) return [];

    if (type === "ssd") {
      return [
        { value: convertToGB(system), name: "auto" },
        { value: 0, name: "system" },
        {
          value: convertToGB(used),
          name: "self",
        },
        {
          value: convertToGB(avail),
          name: "left",
        },
      ];
    }

    if (type === "hdd") {
      return [
        { value: convertToGB(system), name: "system" },
        { value: convertToGB(hdd?.autoBackup), name: "auto" },
        {
          value: convertToGB(hdd?.manualBackup),
          name: "self",
        },
        {
          value: convertToGB(avail),
          name: "left",
        },
      ];
    }
  };

  return (
    <S.DBDriveStatusBox>
      <S.DriveTitle>
        {type === "ssd" && "DB 저장소 공간(SSD)"}
        {type === "hdd" && "백업 저장소 공간(HDD)"}
      </S.DriveTitle>
      <S.DriveChartBox>
        <PieChart
          currentLabel="전체 사용공간"
          totalLabel="총 저장소 용량"
          total={convertToGB(total)}
          used={
            type === "ssd"
              ? parseFloat((convertToGB(used) + convertToGB(system)).toFixed(2))
              : parseFloat((convertToGB(used) + convertToGB(system)).toFixed(2))
          }
          data={getChartData()}
        />

        <S.DriveStatusList>
          <DriveStatusItem
            title="시스템 사용량"
            value={`${convertToGB(system)}GB`}
            color="primary100"
          />
          <DriveStatusItem
            title="DB 사용량"
            value={`${convertToGB(used)}GB`}
            color="yellowStatus"
          />
          <DriveStatusItem
            title="자동백업"
            value={`${convertToGB(hdd?.autoBackup)}GB`}
            color="redStatus"
          />
          <DriveStatusItem
            title="수동백업"
            value={`${convertToGB(hdd?.manualBackup)}GB`}
            color="yellowStatus"
          />
          <DriveStatusItem
            title="잔여공간"
            value={`${convertToGB(avail)}GB`}
            color="gray100"
          />
        </S.DriveStatusList>
      </S.DriveChartBox>
    </S.DBDriveStatusBox>
  );
};
